import type { Category, CategoryNode } from "@/shared/lib/db-schema";

/** Build a parent→children tree from a flat, sorted category list. */
export function buildCategoryTree(flat: ReadonlyArray<Category>): ReadonlyArray<CategoryNode> {
  const map = new Map<string, CategoryNode>();
  const roots: CategoryNode[] = [];
  for (const c of flat) map.set(c.id, { ...c, children: [] });
  for (const node of map.values()) {
    if (node.parent_id !== null && map.has(node.parent_id)) {
      map.get(node.parent_id)!.children.push(node);
    } else {
      roots.push(node);
    }
  }
  return roots;
}
